export class DateUtils {

  static fromDate(d: Date): Date {
    if (!d) {
      return null;
    }
    return new Date(d);
  }
}
